/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Attempts to pretty-print any given input using JSON.stringify, and falls back to an error message
 * if it cannot be serialized.
 * @param code any input
 */
export const prettyPrint = (code: any): string => {
    try {
        return JSON.stringify(code, null, 4);
    } catch {
        return 'JSON.stringify() was unable to serialize the input.';
    }
};
